// TODO: delete or shorten this file when Operators Page and Licenses Page refactors are done (OC-866)
import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'
import logger from '@/utils/_legacy/logger'
import { getOperatorsForProperty } from '@/utils/api/getOperatorsLicenses/getOperatorsLicenses.helpers'
import { notifyError } from '@/utils/notifyError'

import { ddeApi } from './ddeApi'
import { getOperatorsWithUsersCount } from './operatorsService'

export async function getOperatorPropertyLicenses(licenseProperty: string, signal?: AbortSignal) {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DDE) {
    try {
      const [{ data: operatorsLicenses }, operators] = await Promise.all([
        ddeApi.endpoints.operators.getAllLicensePropertiesWithOperators(signal),
        getOperatorsWithUsersCount()
      ])

      const operatorsArray = Array.isArray(operators) ? operators : []
      const filteredOperators = operatorsArray.length
        ? getOperatorsForProperty(licenseProperty, operatorsLicenses, operatorsArray)
        : []

      const BATCH_SIZE = 5
      const operatorBatches = []
      for (let i = 0; i < filteredOperators.length; i += BATCH_SIZE) {
        operatorBatches.push(filteredOperators.slice(i, i + BATCH_SIZE))
      }

      const batchResults = []
      for (const batch of operatorBatches) {
        const batchLicenses = await Promise.all(
          batch.map((operator) =>
            ddeApi.endpoints.operators.getOperatorLicenses(operator.id).catch((error) => {
              logger.error(error, `Error fetching licenses for operator ID: ${operator.id}`)
              notifyError(`Error fetching operator licenses for operator ID: ${operator.id}`)
              return null
            })
          )
        )

        const batchWithLicenses = batch.map((operator, index) => ({
          ...operator,
          license: batchLicenses[index]?.data
        }))

        batchResults.push(...batchWithLicenses)

        if (operatorBatches.length > 1) {
          await new Promise((resolve) => setTimeout(resolve, 500))
        }
      }

      return batchResults
        .filter((operator) => operator.license !== null)
        .map((operator) => ({
          ...operator,
          license: Array.isArray(operator.license) ? operator.license : []
        }))
    } catch (error) {
      logger.error(error, 'Error in getOperatorPropertyLicenses')
      notifyError('Error fetching operator licenses for license property: ' + licenseProperty)
      return []
    }
  }

  throw new Error('Unsupported platform')
}
